import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { useLang } from "@/context/LangContext";

export default function PaymentCancel() {
  const { t } = useLang();
  return (
    <div data-testid="payment-cancel" className="max-w-lg mx-auto px-4 pt-32 pb-32 text-center">
      <XCircle className="w-14 h-14 text-[#9C8F94] mx-auto mb-6" />
      <h1 className="font-serif text-4xl mb-3">{t("payment_cancel")}</h1>
      <p className="text-[#8C7E83] mb-8">{t("payment_cancel_desc")}</p>
      <Link to="/premium" className="inline-flex bg-[#C6899E] text-[#4A2233] rounded-full px-7 py-3 text-sm uppercase tracking-[0.15em] hover:bg-[#B4718C] transition-colors">
        {t("nav_premium")}
      </Link>
    </div>
  );
}
